import api from "./axios"

class serviceAuxiliaresSintegra {
  async generate(dataToGenerateSintegra) {
    const { data } = await api.post(`/auxiliares-sintegra`, dataToGenerateSintegra)
    return data
  }
}

export default new serviceAuxiliaresSintegra()